import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const putAlertImmutableauditreadCountSlice = createApi(`PutAlertImmutableauditreadCountSlice`,"PUT");

const PutAlertImmutableauditreadCountSlice = createSlice({
  name: 'PutAlertImmutableauditreadCountSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putAlertImmutableauditreadCountSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(putAlertImmutableauditreadCountSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(putAlertImmutableauditreadCountSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PutAlertImmutableauditreadCountSlice.reducer;